export const PROJECT_CREATE_LOAD_START_MARK_KEY = 'PROJECT_CREATE_LOAD_START_MARK_KEY';
export const PROJECT_CREATE_LOAD_END_MARK_KEY = 'PROJECT_CREATE_LOAD_END_MARK_KEY';
export const PROJECT_CREATE_READY_MARK_KEY = 'PROJECT_CREATE_READY_MARK_KEY';
export const PROJECT_CREATE_APP_NAME = 'project-create';
export const PROJECT_CREATE_JWM_ONBOARDING = 'projectCreateJwmOnboarding';
